/**
 * 统一的语言管理模块
 * 所有语言相关的配置、获取、切换都从这里走
 */
import Storage from './storage'
import i18n from '@/i18n'

// Element Plus 语言包
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import ja from 'element-plus/es/locale/lang/ja'

/** 支持的语言配置 */
export const LOCALE_CONFIG = {
  'zh-CN': {
    label: '中文',
    elementPlusLocale: zhCn,
    acceptLanguage: 'zh-CN',
  },
  'ja-JP': {
    label: '日本語',
    elementPlusLocale: ja,
    acceptLanguage: 'ja-JP',
  },
}

export const SUPPORTED_LOCALES = Object.keys(LOCALE_CONFIG)
export const DEFAULT_LOCALE = 'zh-CN'

/**
 * 获取当前语言代码
 */
export function getCurrentLocale() {
  // const saved = Storage.get('locale')
  // return SUPPORTED_LOCALES.includes(saved) ? saved : DEFAULT_LOCALE
  return 'ja-JP'
}

/**
 * 设置语言（持久化 + 同步 i18n）
 */
export function setLocale(lang) {
  if (!SUPPORTED_LOCALES.includes(lang)) return
  Storage.set('locale', lang)
  i18n.global.locale.value = lang
}

/**
 * 获取当前语言对应的 Element Plus locale 对象
 */
export function getElementPlusLocale() {
  return LOCALE_CONFIG[getCurrentLocale()].elementPlusLocale
}

/**
 * 获取当前语言对应的 Accept-Language 请求头值
 */
export function getAcceptLanguage() {
  return LOCALE_CONFIG[getCurrentLocale()].acceptLanguage
}
